<script>
import CommonMixin from './CommonMixin';

export default {
  name: 'OverlayRoute',
  mixins: [CommonMixin],
  computed: {
    hasControls () {
      return [
        'controlsTrigger',
        'controlsGrip',
        'controlsMenu',
        'controlsTouchpad',
        'controlsExtra',
      ].some(control => this.$store.getters.playingGame[control]);
    },
  },
};
</script>

<template lang="pug">
div.overlay-route
  div.wrapper.inline-flex
    PanelContainer.statusboxpanel.panel.mr4(id="statuspanel")
      StatusBoxConnected.h-100.w-100
    PanelContainer.panel(id="controlspanel" v-if="hasControls")
      ControlsBoxGameConnected.h-100
  PanelContainer.settingsbox.shrink-0.w-100(v-if="!$permissions['content-only']" id="settingspanel" :usage="'auto'" :duplicatePanel="true" style="height: 20rem" :noTitle="true")
    .flex.justify-center.items-center.h-100
      SettingsBoxConnected
</template>

<style scoped lang="postcss">
.overlay-route {
  & .panel {
    width: 500px;
    flex-shrink: 0;
  }
  & .statusboxpanel {
    width: 240px;
  }
}
</style>
